import { Form, Col, Input, Button } from "antd";
import { StyledUserProfileGroupBtn } from "../../index.styled";
import AppRowContainer from "@lib/components/AppComponents/AppRowContainer";
import { Manager } from "@lib/types/Manager";
import { useIntl } from "react-intl";
import { useEffect, useMemo } from "react";
import { authSchema as yupSchema } from "@lib/schemas/auth";
import { createYupSync } from "@lib/helpers/TableHelper";
import { AppCard } from "@lib/components/AppComponents";
import { MyProfileTabProps } from "..";

const PersonalInfo = ({ query, updateQuery, loading }: MyProfileTabProps) => {
  const { messages } = useIntl();
  const [form] = Form.useForm();
  const apiData = useMemo(() => query?.data?.data, [query?.data]);
  useEffect(() => {
    form.setFieldsValue(apiData);
  }, [apiData]);

  const handleSubmit = async (values: Partial<Manager>) => {
    await updateQuery.mutateAsync({
      ...apiData,
      ...values,
    });
    query.refetch();
  };

  return (
    <AppCard style={{ padding: "20px" }} loading={loading}>
      <Form form={form} onFinish={handleSubmit}>
        <AppRowContainer>
          <Col xs={24} md={12}>
            <Form.Item
              name="firstName"
              rules={[createYupSync({ schema: yupSchema })]}
            >
              <Input placeholder={messages["common.firstName"] as string} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="lastName"
              rules={[createYupSync({ schema: yupSchema })]}
            >
              <Input placeholder={messages["common.lastName"] as string} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="email"
              rules={[createYupSync({ schema: yupSchema })]}
            >
              <Input
                type="text"
                placeholder={messages["common.email"] as string}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <StyledUserProfileGroupBtn
              shouldUpdate
              className="user-profile-group-btn"
            >
              <Button
                type="primary"
                htmlType="submit"
                loading={updateQuery.isPending}
                disabled={updateQuery.isPending}
              >
                {messages["common.save"] as string}
              </Button>
            </StyledUserProfileGroupBtn>
          </Col>
        </AppRowContainer>
      </Form>
    </AppCard>
  );
};

export default PersonalInfo;
